/** A cache change that can be taken back: what dispatching `updateQueryData` returns. */
interface UndoablePatch {
    undo(): void;
}

/**
 * Keeps a cache change made ahead of its request (an optimistic update)
 * only if the request succeeds; when it fails the change is taken back.
 * The failure itself reaches the mutation's caller, so it is not rethrown.
 */
export async function applyOptimistic(patch: UndoablePatch, request: Promise<unknown>): Promise<void> {
    try {
        await request;
    } catch {
        patch.undo();
    }
}
